import { render, staticRenderFns } from "./fdInventory25.vue?vue&type=template&id=1934ff3d"
import script from "./fdInventory25.vue?vue&type=script&lang=js"
export * from "./fdInventory25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports